import ValidProgramId from '../services/programId';

const validProgramId = new ValidProgramId();

// eslint-disable-next-line consistent-return
export default (to, from, next) => {
  if (sessionStorage.renewal) {
    // bypass para renovaçõess
    next();
  } else {
    const { programId } = to.params;
    if (!programId)
      return next({
        name: 'erro'
      });
    validProgramId
      .doValidProgramId(programId)
      .then(res => {
        const {
          einstein = '0',
          omt_sharecare: omtSharecare = '0',
          telemedicina_sharecare_individual: telemedicinaSharecareIndividual = '0',
          telemedicina_sharecare_familiar: telemedicinaSharecareFamiliar = '0',
          utm_source: utmSource = undefined,
          xtra = undefined
        } = to.query;

        sessionStorage.setItem(
          'is_telemedicina',
          einstein === '1' ? res.data.data.is_telemedicina : 'false'
        );

        sessionStorage.setItem(
          'is_omt_sharecare',
          omtSharecare === '1' ? res.data.data.is_omt_sharecare : 'false'
        );

        sessionStorage.setItem(
          'is_telemedicina_sharecare_individual',
          telemedicinaSharecareIndividual === '1'
            ? res.data.data.is_telemedicina_sharecare_individual
            : 'false'
        );

        sessionStorage.setItem(
          'is_telemedicina_sharecare_familiar',
          telemedicinaSharecareFamiliar === '1'
            ? res.data.data.is_telemedicina_sharecare_familiar
            : 'false'
        );

        sessionStorage.setItem('einstein', einstein);
        sessionStorage.setItem(
          'telemedicina_sharecare_individual',
          telemedicinaSharecareIndividual
        );
        sessionStorage.setItem('telemedicina_sharecare_familiar', telemedicinaSharecareFamiliar);
        sessionStorage.setItem('omt_sharecare', omtSharecare);
        sessionStorage.setItem('env', res.data.data.environment);

        if (utmSource) {
          sessionStorage.setItem('utm_source', utmSource);
        }

        if (xtra) {
          sessionStorage.setItem('xtra', xtra);
        }

        return next();
      })
      .catch(() =>
        next({
          name: 'erro'
        })
      );
  }
};
